
import { EFilter } from '@/helpers/enums'
import { defaultDurationRange } from '@/helpers/search'

export default {
  name: 'Duration',
  props: {
    name: { type: String, default: '' }
  },
  data() {
    return {
      selectedMin: defaultDurationRange[0],
      selectedMax: defaultDurationRange[1],
      rangeMarker: defaultDurationRange
    }
  },

  fetch() {
    this.applyFilter(this.$route.query[EFilter.DURATION])
  },

  computed: {
    selectedMinText() {
      return this.$t('talent.project.search.duration.from', {
        duration: this.selectedMin
      })
    },

    selectedMaxText() {
      return this.$t('talent.project.search.duration.until', {
        duration: this.selectedMax
      })
    }
  },

  watch: {
    [`$route.query.${EFilter.DURATION}`](data) {
      if (!data) {
        this.rangeMarkerFn(defaultDurationRange)
      }
    }
  },

  methods: {
    applyFilter(data) {
      if (data) {
        const buildRangeMarker = data.split(',').map((i) => Number(i))
        this.rangeMarkerFn(buildRangeMarker)
      }
    },

    async rangeMarkerFn(val) {
      this.$emit('before-update')
      this.rangeMarker = val

      const rangeQuery = val.join(',')
      const checkDefaultDurationRange = defaultDurationRange.join(',')
      const bool = rangeQuery !== checkDefaultDurationRange
      this.selectedMin = val[0]
      this.selectedMax = val[1]

      if (bool) {
        await this.$updateQuery(this.$route.query, { [EFilter.DURATION]: rangeQuery })
      } else {
        await this.$cleanQuery(this.$route.query, EFilter.DURATION)
      }

      this.$emit('updated')
    },

    clearFilter() {
      this.rangeMarkerFn(defaultDurationRange)
    }
  }
}
